module.exports = __webpack_public_path__ + "media/img/home/gallery/gallery5-6a649ac305c094bcba4ce0d4a36cc9fd.png";